var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78174 25.6404C4.95002 25.6404 5.89697 26.5883 5.89697 27.7566V36.2175C5.89697 37.3858 4.95002 38.3328 3.78174 38.3328C2.61351 38.3327 1.6665 37.3858 1.6665 36.2175V27.7566C1.6665 26.5883 2.61351 25.6404 3.78174 25.6404ZM19.9995 12.948C21.1678 12.948 22.1147 13.8959 22.1147 15.0642V36.2175C22.1146 37.3857 21.1677 38.3328 19.9995 38.3328C18.8314 38.3327 17.8844 37.3857 17.8843 36.2175V15.0642C17.8843 13.8959 18.8313 12.948 19.9995 12.948ZM36.2173 1.66675C37.3855 1.66675 38.3325 2.57885 38.3325 3.70386V36.2957C38.3325 37.4207 37.3855 38.3328 36.2173 38.3328C35.0489 38.3328 34.1021 37.4207 34.1021 36.2957V3.70386C34.1021 2.57885 35.0489 1.66676 36.2173 1.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/DashIcon.02aa0db4d889daef4c8163e57945999d.svg";
export { ForwardRef as ReactComponent };